'use client';

/* empty css                                     */
/* empty css                                        */
import "./src/themes/color.css.ts.vanilla.css.js";
/* empty css                                     */
/* empty css                                      */
/* empty css                                      */
/* empty css                                       */
/* empty css                                        */
/* empty css                                         */
import "./src/atomic/sprinkles.ts.vanilla.css.js";
/* empty css                                          */
var visuallyHidden = "c5-19-3_1lxmpax1 c5-19-3_1lxmpax0 c5-19-3_nly6ul3b c5-19-3_nly6ul3d c5-19-3_161xunp8 c5-19-3_161xunp24 c5-19-3_161xunp40 c5-19-3_161xunp5w c5-19-3_161xunp7s c5-19-3_161xunp9o c5-19-3_161xunpbk c5-19-3_161xunpdg c5-19-3_nly6uls c5-19-3_zqwrxxs";
var fillParent = "c5-19-3_1lxmpax5 c5-19-3_1lxmpax4 c5-19-3_nly6uls c5-19-3_1lxmpax3 c5-19-3_1lxmpax2 c5-19-3_nly6ul3j c5-19-3_nly6ul3m c5-19-3_nly6ul3k c5-19-3_nly6ul3l";
var fillParentAfter = "c5-19-3_1lxmpax6";
var fillScreen = "c5-19-3_1lxmpax8 c5-19-3_1lxmpax7 c5-19-3_nly6ulw c5-19-3_1lxmpax3 c5-19-3_1lxmpax2 c5-19-3_nly6ul3j c5-19-3_nly6ul3m c5-19-3_nly6ul3k c5-19-3_nly6ul3l";
var absoluteCentered = "c5-19-3_1lxmpaxa c5-19-3_1lxmpax9 c5-19-3_nly6uls c5-19-3_nly6ul4";
var chalkFocusRules = { high: { boxShadow: "white 0px 0px 0px 4px, #2A4ECC 0px 0px 0px 6px, #2A4ECC 0px 0px 1px 6px" }, medium: { boxShadow: "#2A4ECC 0px 0px 0px 2px, white 0px 0px 0px 3px" }, low: { boxShadow: "#2A4ECC 0px 0px 0px 2px" } };
var chalkFocus = { high: "c5-19-3_1lxmpaxb", medium: "c5-19-3_1lxmpaxc", low: "c5-19-3_1lxmpaxd" };
var chalkFocusWithin = { high: "c5-19-3_1lxmpaxe", medium: "c5-19-3_1lxmpaxf", low: "c5-19-3_1lxmpaxg" };
var chalkFocusWithActiveOutline = { high: "c5-19-3_1lxmpaxh", medium: "c5-19-3_1lxmpaxi", low: "c5-19-3_1lxmpaxj" };
var chalkFocusWithTransparentBg = { high: "c5-19-3_1lxmpaxk" };
export {
  absoluteCentered,
  chalkFocus,
  chalkFocusRules,
  chalkFocusWithActiveOutline,
  chalkFocusWithTransparentBg,
  chalkFocusWithin,
  fillParent,
  fillParentAfter,
  fillScreen,
  visuallyHidden
};
